module.exports = __webpack_public_path__ + "static/media/35.140743a0.jpg";